import styled from 'styled-components';
import { FlexRow, Text } from '@make-software/tg-mini-app-ui';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flex: '0 0 auto',
  width: '100%',
  background: theme.colors.cardBg,
  zIndex: '999',
  '@media only screen and (min-width: 769px)': {
    width: '640px'
  }
}));

export const AccountContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    borderRadius: '4px',
    backgroundColor: '#30313B',
    padding: '8px 12px',
    marginRight: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#FB6F6A',
    div: {
      textAlign: 'center',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center'
    },
    svg: {
      width: '12px',
      heigth: '12px',
      path: {
        fill: '#FB6F6A'
      }
    }
  })
);

export const ActivityText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 'normal',
    color: '#FB6F6A',
    fontFamily: 'Inter',
    '@media (max-width: 480px)': {
      display: 'none'
    }
  })
);
